export default "__VITE_ASSET__QdbuAO4L__"